import { cn } from 'component-library';

import { FormControl, FormItem } from '@/components/Form';
import { Calendar, CalendarProps } from '@/components/widgets/a/Calendar/Calendar';

import { useControlsContext } from './Form';

type FormCalendarProps = {
  formName: string;
  minFormName: string;
  maxFormName: string;
} & CalendarProps;

export const FormCalendar = ({ id, formName, placeholder, maxFormName, minFormName, className }: FormCalendarProps) => {
  const { setValue, watch } = useControlsContext();

  const selectedFormValue = watch(formName);
  const minFormValue = minFormName ? watch(minFormName) : undefined;
  const maxFormValue = maxFormName ? watch(maxFormName) : undefined;

  const handleValueChange = (date: string | null) => {
    setValue(formName, date);
  };

  return (
    <FormItem className={cn('w-full', className)}>
      <FormControl>
        <Calendar
          id={id}
          onChange={handleValueChange}
          name={formName}
          value={selectedFormValue}
          placeholder={placeholder}
          max={maxFormValue}
          min={minFormValue}
        />
      </FormControl>
    </FormItem>
  );
};
